import { useEditor, useNode } from "@craftjs/core";
import { Button, Grid } from "@mui/material";
import SettingsItem from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemRadio from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItemRadio";
import SettingsItemText from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "../../../components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";

const Settings = () => {
    const {
        id,
        actions: { setProp },
    } = useNode();
    const { displayName, mediaSource, mediaType, isExternal, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
        mediaSource: state.nodes[id] && state.nodes[id].data.props.src,
        mediaType: state.nodes[id] && state.nodes[id].data.props.type,
        isExternal: state.nodes[id] && state.nodes[id].data.props.mediaSource === "external",
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection title="Media">
                <Grid size={{ xs: 12 }}>
                    <SettingsItem propKey="mediaSource" type="radio" label="Media Source" fullWidth>
                        <SettingsItemRadio value={"upload"} label="Upload own file" />
                        <SettingsItemRadio value={"external"} label="Link to external resource" />
                    </SettingsItem>
                </Grid>
                {isExternal && (
                    <>
                        <Grid size={{ xs: 12 }}>
                            <SettingsItem propKey="type" type="radio" label="Media Type" fullWidth>
                                <SettingsItemRadio value={"image"} label="Image" />
                                <SettingsItemRadio value={"video"} label="Video" />
                            </SettingsItem>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <SettingsItemText
                                type={"text"}
                                value={mediaSource}
                                onChange={(value: string) => {
                                    actions.setProp(id, (props) => (props.src = value));
                                }}
                                fullWidth={true}
                                label="External URL"
                            />
                        </Grid>
                    </>
                )}
                <Grid size={{ xs: 12 }}>
                    {Boolean(mediaSource) && (
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            size="small"
                            onClick={() => {
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                setProp((prop: any) => {
                                    prop.src = "";
                                    prop.type = "";
                                });
                            }}
                        >
                            Clear file
                        </Button>
                    )}
                </Grid>
            </SettingsSection>
            {mediaType === "image" && (
                <SettingsSection title="Properties">
                    <SettingsItem propKey="alt" fullWidth multiline rows={5} type="text" label="Alt text" />
                </SettingsSection>
            )}
            <SettingsSection
                title="Dimensions"
                props={["width", "height"]}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                summary={({ width, height }: any) => {
                    return `${width || 0} x ${height || 0}`;
                }}
            >
                <SettingsItem propKey="width" type="text" label="Width" />
                <SettingsItem propKey="height" type="text" label="Height" />
            </SettingsSection>
        </>
    );
};

export default Settings;
